exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-as-row {\r\n  cursor: pointer;\r\n  margin: 5px;\r\n}\r\n.card-as-row:hover {\r\n  box-shadow: rgba(63,81,181,1) 0 0 15px;\r\n}\r\n.selected {\r\n  background: rgba(63,81,181,1);\r\n  color: white;\r\n}\r\n.header-ratio-1 {\r\n  width: 30% !important;\r\n  -webkit-box-flex: 0;\r\n      -ms-flex: none;\r\n          flex: none;\r\n}\r\n.header-ratio-2 {\r\n  width: 50% !important;\r\n  -webkit-box-flex: 0;\r\n      -ms-flex: none;\r\n          flex: none;\r\n}\r\n.inline-div {\r\n  display: inline-block !important;\r\n  -webkit-box-flex: 0;\r\n      -ms-flex: none;\r\n          flex: none;\r\n}\r\n.vote-detail-row-1 {\r\n  display: inline-block;\r\n  width: 20%;\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n.vote-detail-row-2 {\r\n  display: inline-block;\r\n  width: 75%;\r\n}\r\n\r\n.fib-row-1 {\r\n  text-align: center;\r\n  display: inline-block;\r\n  width: 20%;\r\n}\r\n.fib-row-2 {\r\n  display: inline-block;\r\n  width: 70%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/AppDev/meetup/kla-firebase-poker/web/src/app/component/ticket-vote/ticket-vote.component.css
// module id = ../../../../../src/app/component/ticket-vote/ticket-vote.component.css
// module chunks = main